export const APP_TAB = {
  "Tab.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Tab.Width": {
    defaultValue: "100%"
  },
  "Tab.Height": {
    defaultValue: "auto"
  },
  "Tab.Min.Width": {
    defaultValue: "unset"
  },
  "Tab.Max.Height": {
    defaultValue: "unset"
  },
  "Tab.Max.Width": {
    defaultValue: "unset"
  },
  "Tab.Min.Height": {
    defaultValue: "150px"
  },
  "Tab.Border.Style": {
    defaultValue: "solid"
  },
  "Tab.Border.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Tab.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Tab.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Tab.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Tab.Margin.Top": {
    defaultValue: "0px"
  },
  "Tab.Margin.Right": {
    defaultValue: "0px"
  },
  "Tab.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Tab.Margin.Left": {
    defaultValue: "0px"
  },
  "Tab.Padding.Top": {
    defaultValue: "0px"
  },
  "Tab.Padding.Right": {
    defaultValue: "0px"
  },
  "Tab.Padding.Bottom": {
    defaultValue: "0px"
  },
  "Tab.Padding.Left": {
    defaultValue: "0px"
  },
  "Tab.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Gap": {
    defaultValue: "0px"
  },
  "Tab.Item.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Item.Selected.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Header.Bg.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Item.Icon.Size": {
    defaultValue: "16px"
  },
  "Tab.Item.Icon.Color": {
    ref: "Color.Gray.700"
  },
  "Tab.Item.Font.Size": {
    ref: "Font.Size.14"
  },
  "Tab.Item.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Tab.Item.Hover.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Tab.Item.Color": {
    ref: "Color.Black"
  },
  "Tab.Item.Selected.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Font.Style": {
    defaultValue: "normal"
  },
  "Tab.Item.Text.Decoration": {
    defaultValue: "none"
  },
  "Tab.Item.Line.Height": {
    ref: "Line.Height.Base"
  },
  "Tab.Item.Letter.Spacing": {
    ref: "Letter.Spacing.Base"
  },
  "Tab.Item.Padding.Left": {
    ref: "Space.12"
  },
  "Tab.Item.Padding.Right": {
    ref: "Space.12"
  },
  "Tab.Item.Padding.Top": {
    ref: "Space.8"
  },
  "Tab.Item.Padding.Bottom": {
    ref: "Space.8"
  },
  "Tab.Item.Border.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Item.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Selected.Hover.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Hover.Icon.Size": {
    ref: "Tab.Item.Icon.Size"
  },
  "Tab.Item.Hover.Icon.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Hover.Border.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Item.Hover.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Hover.Selected.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Selected.Font.Weight": {
    ref: "Font.Weight.Medium"
  },
  "Tab.Item.Selected.Icon.Size": {
    ref: "Tab.Item.Icon.Size"
  },
  "Tab.Item.Selected.Icon.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Selected.Border.Color": {
    ref: "Color.Primary.500"
  },
  "Tab.Item.Selected.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Bottom.Width": {
    defaultValue: "2px"
  },
  "Tab.Item.Selected.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Item.Selected.Padding.Left": {
    ref: "Tab.Item.Padding.Left"
  },
  "Tab.Item.Selected.Padding.Right": {
    ref: "Tab.Item.Padding.Right"
  },
  "Tab.Item.Selected.Padding.Top": {
    ref: "Tab.Item.Padding.Top"
  },
  "Tab.Item.Selected.Padding.Bottom": {
    ref: "Tab.Item.Padding.Bottom"
  },
  "Tab.Container.Flex.Direction": {
    defaultValue: "row"
  },
  "Tab.Container.Flex.Wrap": {
    defaultValue: "wrap"
  },
  "Tab.Container.Row.Gap": {
    defaultValue: "0px"
  },
  "Tab.Container.Column.Gap": {
    defaultValue: "0px"
  },
  "Tab.Container.Width": {
    defaultValue: "100%"
  },
  "Tab.Container.Min.Width": {
    defaultValue: "unset"
  },
  "Tab.Container.Margin.Top": {
    defaultValue: "0px"
  },
  "Tab.Container.Margin.Right": {
    defaultValue: "0px"
  },
  "Tab.Container.Margin.Bottom": {
    defaultValue: "0px"
  },
  "Tab.Container.Margin.Left": {
    defaultValue: "0px"
  },
  "Tab.Container.Padding.Top": {
    defaultValue: "10px"
  },
  "Tab.Container.Padding.Right": {
    defaultValue: "10px"
  },
  "Tab.Container.Padding.Bottom": {
    defaultValue: "10px"
  },
  "Tab.Container.Padding.Left": {
    defaultValue: "10px"
  },
  "Tab.Container.Border.Top.Width": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Right.Width": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Bottom.Width": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Left.Width": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Color": {
    ref: "Color.Black"
  },
  "Tab.Container.Border.Top.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Bottom.Right.Radius": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Bottom.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Container.Border.Top.Left.Radius": {
    defaultValue: "0px"
  },
  "Tab.Container.Height": {
    defaultValue: "100%"
  },
  "Tab.Container.Overflow": {
    defaultValue: "auto"
  },
  "Tab.Container.Align.Items": {
    defaultValue: "flex-start"
  },
  "Tab.Container.Justify.Content": {
    defaultValue: "flex-start"
  },
  "Tab.Container.Align.Content": {
    defaultValue: "flex-start"
  },
  "Tab.Container.Display": {
    defaultValue: "flex"
  },
  "Tab.Container.Min.Height": {
    defaultValue: "unset"
  },
  "Tab.Container.Box.Sizing": {
    defaultValue: "border-box"
  },
  "Tab.Container.Background": {
    ref: "Color.Transparent"
  },
  "Tab.Container.Background.Color": {
    ref: "Color.Transparent"
  },
  "Tab.Container.Border.Style": {
    defaultValue: "solid"
  },
  "Tab.Container.Max.Height": {
    defaultValue: "unset"
  },
  "Tab.Container.Max.Width": {
    defaultValue: "unset"
  },
  "Tab.Container.Box.Shadow": {
    defaultValue: "none"
  },
  //Old meta support
  "Tab.Color": {
    ref: "Tab.Item.Color"
  },
  "Tab.Active.Color": {
    ref: "Tab.Item.Selected.Color"
  },
  "Tab.Hover.Color": {
    ref: "Tab.Item.Hover.Color"
  },
  "Tab.More.Icon.Color": {
    ref: "Font.Size.14"
  },
  "Tab.More.Icon.Bg.Color": {
    ref: "Color.White"
  },
  "Tab.Cursor": {
    defaultValue: "pointer"
  }
};
